import { Merchant } from "@/types/merchant";
import {
  createFileRoute,
  Navigate,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { useSelectedApplication } from "@/hooks/use-selected-application";

/**
 * Needs hasVirtualAccountsEnabled to be true
 */
export function shouldShowBalances(
  selectedApplication: Merchant["applications"][number],
) {
  return selectedApplication.hasVirtualAccountsEnabled;
}

export const Route = createFileRoute("/(app)/_main-layout/_balances/balances")({
  component: () => <BalancesLayoutComponent />,
  beforeLoad: ({ location }) => {
    if (location.pathname === "/balances") {
      throw redirect({ to: "/balances/overview", search: (s) => s });
    }
  },
});

const BalancesLayoutComponent = () => {
  const selectedApplication = useSelectedApplication();

  if (!shouldShowBalances(selectedApplication)) {
    return <Navigate to="/payments/payin" />;
  }

  return (
    <div className="w-full min-w-0">
      <div className="mb-5">
        <h1 className="text-xl font-semibold text-slate-900">Balances</h1>
        <p className="mt-0.5 text-sm text-slate-500">
          View account balances and manage payouts
        </p>
      </div>
      <Outlet />
    </div>
  );
};
